const bases= {
    sso: {
        api: process.env.VUE_APP_SSO_API_BASE_URL,
            ui: process.env.VUE_APP_SSO_WEB_BASE_URL,
    },
    members: {
        api: process.env.VUE_APP_MEMBERS_API_BASE_URL,
            ui: process.env.VUE_APP_MEMBERS_WEB_BASE_URL,
    },
    training: {
        api: process.env.VUE_APP_TRAINING_API_BASE_URL,
        ui: process.env.VUE_APP_TRAINING_WEB_BASE_URL,
    }
};

export var routes = {
    home: bases.sso.ui + "/",
    users: {
        management: bases.sso.ui + "/user/management"
    },
    members: {
        member: {
            edit: `${bases.members.ui}/member/edit`,
        },
    }
    
};

export var roles = {
    home: null,
    nothing: null,
    users: {
        management: ["ADMIN"]
    },
    members: {
        member: {
            management: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
            add: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD'],
            edit: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
        },
        unit: {
            management: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            add: ["ADMIN"]
        },
        census: {
            management: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            add: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            submit: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        },
        licenses: {
            active: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            add: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            pending: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        },
        support: {
            active: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            add: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            pending: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        },
        report: {
            census: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
            profiles: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        },
        conference: {
            management: ["ADMIN"]
        },
        jamboree: {
            management: ["ADMIN"],
            edit: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        }
    },
    training: {
        trainings: ['TRAINING_ADMIN', 'TRAIN_MOD', 'TRAINER'],
        leaders: ['TRAINING_ADMIN'],
        parametrics: ['TRAINING_ADMIN'],
        participation: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
    },
    flex: {
        plansList: [],
        applyActivitiesList: [],
        trainerApplyActivitiesList: [],
        applyActivitiesMgmt: []
    },
    excursions: {
        excursionActivities: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN', 'COMMISSION_PRESIDENT',
            'EXCURSION_VIEWER', 'AFFAIRS_COMMISSIONER', 'NAVY_COMMISSIONER', 'CAPTAIN', 'BRANCH_COMMISSIONER'],
    }
};

